<template>
  <div class="gradient" style="width: 100%; display: flex;align-items: center;justify-content: center;">
    <div style="margin: 40px; padding: 40px; display: flex;flex-flow:column;align-items: center;justify-content: center;">
      <div style="font-size: 32px; margin-top: 20px;">审核中</div>
      <div style="margin-top: 10px; color: #0e9aef;">您的资料正在审核中，预计时间1-3天</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ShowSH',
    mounted () {
      document.title = '审核状态'
    }
  }
</script>

<style scoped>
  .gradient{
    background: -moz-linear-gradient(top, #f3f6fb 0%, #ffffff 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#f3f6fb), color-stop(100%,#ffffff));
    background: -webkit-linear-gradient(top, #f3f6fb 0%,#ffffff 100%);
    background: -o-linear-gradient(top, #f3f6fb 0%,#ffffff 100%);
    background: -ms-linear-gradient(top, #f3f6fb 0%,#ffffff 100%);
    background: linear-gradient(to bottom, #f3f6fb 0%,#ffffff 100%);
  }
</style>



// WEBPACK FOOTER //
// src/components/regedit/ShowSH.vue